export const ErrorBoundaryFallbackTexts = {
    subTitle: 'Что-то пошло не так, но мы уже разбираемся',
    text: 'Код ошибки – 500',
    retryBtn: 'Попробовать еще раз',
    backBtn: 'Вернуться назад',
};
